var map = {
	"./1368Logo.png": "444b",
	"./199xbetLogo.png": "9612",
	"./76betLogo.png": "67e0",
	"./79betLogo.png": "d1d8",
	"./8KBET777Logo.png": "60fc",
	"./amxpjLogo.png": "d492",
	"./betc88Logo.png": "650f",
	"./bggaLogo.png": "0a484",
	"./bom88Logo.png": "de20",
	"./choibetLogo.png": "d355",
	"./dola789Logo.png": "b88d",
	"./ff01Logo.png": "efc2",
	"./ff10Logo.png": "64d6",
	"./g9betLogo.png": "4760",
	"./gtg88Logo.png": "5105",
	"./gtgameLogo.png": "c01a",
	"./jqk79Logo.png": "b3bd",
	"./jramjsLogo.png": "0253",
	"./jrwnsrLogo.png": "e0b9",
	"./jrylLogo.png": "63e7",
	"./jun88Logo.png": "8664",
	"./k88betLogo.png": "cf36",
	"./kubetLogo.png": "b89c",
	"./phattai68Logo.png": "fccd",
	"./seaLogo.png": "5061",
	"./sovipLogo.png": "8d06",
	"./tntbetLogo.png": "d668",
	"./tycaLogo.png": "bf06",
	"./wynnLogo.png": "24cd",
	"./xiaocaoLogo.png": "a8a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d867";